import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useQuery } from "react-query";
import Spinner from "../../../Component/Spinner/Spinner";
import { AuthContext } from "../../../Context/UseContext";
import useScrollToTop from "../../../hooks/useScrollToTop";
import useTitle from "../../../hooks/useTitle";
import { useDbUser } from "../../../hooks/useUser";
import ConfirmationModal from "../../Shared/ConfirmationModal/ConfirmationModal";

const MyProducts = () => {
  useScrollToTop();
  useTitle("My Products");
  const { user, loading } = useContext(AuthContext);
  const [dbUser, isDbUserLoading] = useDbUser(user?.email);
  const [deletingProduct, setDeletingProduct] = useState(null);

  const closeModal = () => {
    setDeletingProduct(null);
  };

  const url = `${process.env.REACT_APP_API_URL}/products/seller/${dbUser?._id}`;

  const { data: product = [], refetch, isLoading } = useQuery({
    queryKey: ["product", dbUser?._id],
    queryFn: async () => {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          authorization: `bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      if (data.success === true) {
        refetch()
        return data;
      } else {
        return [];
      }
    },
  });


  useEffect(() => {
    refetch();
  }, [refetch, isLoading]);

  const handleDeleteProduct = (product) => {
    fetch(`${process.env.REACT_APP_API_URL}/products/seller/${product._id}`, {
      method: "DELETE",
      headers: {
        authorization: `bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.deletedCount > 0);
        refetch()
        toast.success(`${product.title} deleted successfully`);
      });
  };

  const handleAdvertiseProduct = (product) => {
    fetch(
      `${process.env.REACT_APP_API_URL}/products/advertisement/${product._id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `bearer ${localStorage.getItem("token")}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data)
        if (data.success){
          toast.success(`${product.title} advertise successfully`);
        } else {
          toast.error(`${product.title} advertise failed`);
        }
      });
  };
  if(loading || isDbUserLoading || isLoading) {
    return <Spinner/>;
  }

  return (
    <div className="px-5">
      <h4 className="mb-4 text-2xl font-semibold text-gray-600 dark:text-gray-300">
        Products Items
      </h4>
      <div className="w-full overflow-hidden rounded-lg shadow-xs">
        <div className="w-full overflow-x-auto">
          <table className="w-full whitespace-no-wrap ">
            <thead>
              <tr className="text-xs font-semibold tracking-wide text-left text-gray-700 uppercase border-b dark:border-gray-700 bg-gray-300 dark:text-gray-400 dark:bg-black">
                <th className="px-4 py-3">Image</th>
                <th className="px-4 py-3">Product</th>
               <th className="px-4 py-3">Price</th>
               <th className="px-4 py-3">Status</th>
               <th className="px-4 py-3">Posted Date</th>
               <th className="px-4 py-3">Advertise</th>
               <th className="px-4 py-3">Deleted</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-900">
              {
                product?.data?.map((product) => (
                    <tr key={product._id}>
                    <td className="px-4 py-3">
                        <div className="flex items-center space-x-3">
                          <div className="avatar">
                            <div className="mask mask-squircle w-12 h-12">
                              <img
                                src={product.img}
                                alt={product.title}
                              />
                            </div>
                          </div>
                        </div>
                      </td>
                    <td className="px-4 py-3">
                        <div>
                          <div className="font-bold">{product.title}</div>
                        </div>
                      </td>
                    <td>{product.resellerPrice}</td>
                    {
                      product.sold? (
                        <td className="text-red-600">Sold</td>
                      ) : (
                        <td className="text-green-600">stock</td>
                      )
                    }
                    <td className="px-4 py-3">{product.post_time}</td>
                    <td className="px-4 py-3">
                      {
                        product.sold === false ? <label
                          className="btn btn-success btn-sm"
                          onClick={() => handleAdvertiseProduct(product)}
                        >
                          Advertise
                        </label> : <span className='btn btn-true btn-sm disabled'>Advertise</span>
                      }
                    </td>
                      <th>
                        <label
                        onClick={() => setDeletingProduct(product)}
                          htmlFor="confirmation-modal"
                          className="btn btn-error btn-sm">
                          Delete
                        </label>
                      </th>
                    </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
        {deletingProduct && (
        <ConfirmationModal
          title={`Are you sure you want to delete?`}
          message={`If you delete ${deletingProduct.title}. It cannot be undone.`}
          successAction={handleDeleteProduct}
          successButtonName="Delete"
          modalData={deletingProduct}
          closeModal={closeModal}></ConfirmationModal>
      )}
    </div>
  );
};

export default MyProducts;
